import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { useFeatureFlags } from "@packsize/feature-flags";

import { InfoRow } from "./info-row";

export const FeatureFlagsCard: FC = () => {
	const { getAllFeatureFlags } = useFeatureFlags();

	const activeFlags = Object.entries(getAllFeatureFlags()).filter(
		([key, value]) => value === true && !key.startsWith("ff-"),
	);

	return (
		<Card id="developer-feature-flags">
			<CardContent>
				<Typography variant="h3" component="h2" gutterBottom>
					<FormattedMessage id="Feature Flags" defaultMessage="Feature Flags" />
				</Typography>
				<Stack spacing={2}>
					{activeFlags.map(([key]) => (
						<InfoRow key={key} label={key} value="true" />
					))}
				</Stack>
			</CardContent>
		</Card>
	);
};
